export class RefData {
  param: any;
  stateName: string;
  disabled: boolean;
  routerLink: any[];
  queryParams: any;

  constructor(stateName: string, param: any, disabled: boolean) {
    this.stateName = stateName;
    this.param = param;
    this.disabled = disabled;
  }
}
